import NavBar from "../features/navbar/Navbar";
import ProductDetail from "../features/product/components/ProductDetail";
import Footer from "../features/common/Footer";
import MainLayout from "../components/MainLayout";

function ProductDetailPage() {
    return ( 
        <MainLayout>
            <NavBar>
                <ProductDetail></ProductDetail>
            </NavBar>
            <Footer></Footer>
        </MainLayout>
     );
}

export default ProductDetailPage;